export const onSubmitMultipleImages = (
  formName,
  editFormName,
  parentFormName,
  constantList = [],
  form,
  childForm,
  editChildForm
) => {
  let addFields = childForm.getFieldValue()?.[formName] || []
  let editFields = editChildForm.getFieldsValue()?.[formName] || form.getFieldValue([editFormName]) || {}
  let addEditCombinedFields = {}
  let updatedLength = 0

  constantList?.forEach(item => {
    updatedLength = (editFields?.[item?.value]?.length ?? 0) + (addFields?.[item?.value]?.length ?? 0) + updatedLength
    addEditCombinedFields[item.value] = [...(addFields?.[item?.value] || []), ...(editFields?.[item?.value] || [])]
  })

  childForm.resetFields()
  editChildForm.resetFields()

  form.setFieldValue(parentFormName, { list: addEditCombinedFields, count: updatedLength })
  form.setFieldValue(formName, undefined)
  form.setFieldValue(editFormName, addEditCombinedFields)
}

export const transformMultipleImage = files => {
  Object.keys(files || {})?.forEach(key => {
    files[key] = files[key]?.map(item => ({
      ...(item?.id && { id: item?.id }),
      ...(item?.inventoryTypeId && { unitTypeId: +item?.inventoryTypeId }),
      mediaType: key,
      locations: item?.locations?.toString(),
      area: item?.area,
      areaType: item?.areaType,
      s3Key: item?.src?.key || item?.s3Key || item?.src,
      name: item?.name || item?.src?.fileName,
    }))
    if (files[key]?.length === 0) delete files[key]
  })
}

export const transformImageArray = files => {
  return files?.fileList?.map(file => {
    return {
      name: file?.title || file?.originFileObj?.name,
      s3Key: file?.response?.key || file?.s3Key,
    }
  })
}
